import React from 'react';
import iso6391 from "iso-639-1";
import ProgressBar from "../ProgressBar.tsx";
import ProjectStateBadge from "../ProjectStateBadge.tsx";
import {IStateEnum} from "../../models/enums/state.enum.ts";
import SmartIcon from "../SmartIcon.tsx";
import {IoReload} from "react-icons/io5";
import {IGroupProgress} from "../../models/interfaces/groupProgress.interface.ts";
import {useProject} from "../../hooks/useProject.ts";
import {titleCase} from "../../utils/utils.ts";
import {useProjectsStore} from "../../store/useProjectsStore.ts";
import {downloadFeatures} from "../../services/projectService.ts";

interface MultiLanguageFeatureTableProgressProps extends React.PropsWithChildren {
  projectId: string;
  projectName: string;
  feature: IGroupProgress;
  featureName: string;
}

const HEADER_TITLES: string[] = ["language", "progress", "status", "export"];

const MultiLanguageFeatureTableProgress: React.FC<React.PropsWithChildren<MultiLanguageFeatureTableProgressProps>> = (
  {
    projectId,
    projectName,
    feature,
    featureName,
    children,
  }: MultiLanguageFeatureTableProgressProps) => {
  const {resetFeature} = useProjectsStore();
  const {getItemStateEnum} = useProject();

  const downloadLanguageFeature = async (languageCode: string) => {
    const info: {
      subtitles?: string[],
      audioDescriptions?: string[],
      dialogueList?: boolean,
      extendedMetadata?: boolean,
    } = {}
    info[featureName == "subtitleTranslations" ? "subtitles" : "audioDescriptions"] = [languageCode]
    downloadFeatures(projectId,projectName, info).catch(console.error);
  }

  const resetLanguageFeature = async (languageCode: string) => {
    await resetFeature(projectId, featureName, languageCode);
  }

  return (
    <table className="w-full border-separate border-spacing-0">
      <thead className="bg-n-700">
      <tr className="border-b border-n-600">
        {HEADER_TITLES.map((header: string, index: number) => (
            <th key={header} className={`text-${index == 0 ? 'left' : 'center'} px-4 py-2`}>{titleCase(header)}</th>
          )
        )}
      </tr>
      </thead>
      <tbody>
      {children && children}
      {Object.keys(feature).map((itemLang: string) => {
        const progressPct: number | null = feature[itemLang]?.pct || null;
        const targetLanguageState: IStateEnum = getItemStateEnum(feature[itemLang])
        return (
          <tr key={itemLang} className="border-b border-n-600 last:border-b-0">
            <td className="text-left px-4 py-2">{iso6391.getName(itemLang)}</td>
            <td className="text-left px-4 py-2">
              <ProgressBar percentage={progressPct}/>
            </td>
            <td className="text-left px-4 py-2">
              <ProjectStateBadge
                state={targetLanguageState}
                enableTooltip={false}
              />
            </td>
            <td className="text-center px-4 py-2">
              {targetLanguageState == IStateEnum.FAILED ? (
                <div onClick={() => resetLanguageFeature(itemLang)}>
                  <SmartIcon
                    name={IoReload}
                    fill="#fff"
                    className="w-5 h-5 cursor-pointer"
                  />
                </div>
              ) : progressPct == 100 ? (
                <div onClick={() => downloadLanguageFeature(itemLang)}>
                  <SmartIcon
                    name={"download"}
                    fill="#fff"
                    className="w-5 h-5 cursor-pointer"
                  />
                </div>
              ) : null}
            </td>
          </tr>
        )
      })}
      </tbody>
    </table>
  )
}

export default MultiLanguageFeatureTableProgress;